import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/',
    component: () => import('../views/main.vue'),
    children: [
      {
        path: 'userManage',
        component: () => import('../views/userManage/userManage.vue')
      },
      {
        path: 'courseList',
        component: () => import('../views/courseList/courseList.vue')
      },
      {
        path: 'contentConfig',
        component: () => import('../views/contentConfig/contentConfig.vue')
      },
      {
        path: 'classManage',
        component: () => import('../views/classManage/classManage.vue')
      },
      {
        path: 'teachAdmin',
        component: () => import('../views/teachAdmin/teachAdmin.vue')
      },
      {
        path: 'accountManage',
        component: () => import('../views/accountManage/accountManage.vue')
      },
      {
        path: 'teach',
        component: () => import('../views/teach/teach.vue')
      },
      {
        path: 'class',
        component: () => import('../views/class/class.vue')
      },
      {
        path: 'feedback',
        component: () => import('../views/feedback/feedback.vue')
      },
      {
        path: 'feedbackList',
        component: () => import('../views/feedbackList/feedbackList.vue')
      },
      {
        path: 'exportStudent',
        component: () => import('../views/exportStudent/exportStudent.vue')
      }
    ]
  },
]

const router = new VueRouter({
  routes
})

export default router
